import { AnimatePresence, motion } from "framer-motion";
import React, { useState } from "react";
import { HiOutlineMenuAlt3 } from "react-icons/hi";
import { Link, NavLink } from "react-router-dom";
import { CiLocationOn } from "react-icons/ci";
import { FiPhone } from "react-icons/fi";
import { MdOutlineEmail } from "react-icons/md";
import { FaFacebookF, FaInstagram, FaTiktok, FaTwitter } from "react-icons/fa";
import { IoCloseOutline } from "react-icons/io5";
import {
  containerVars,
  menuVars,
  mobileLinkVars,
} from "../../../../utils/motion";
export default function Navbar() {
  const [open, setOpen] = useState(false);

  const toggleMenu = () => {
    setOpen((prevOpen) => !prevOpen);
  };
  const nav = [
    { title: "Home", link: "/" },
    { title: "About Us", link: "/about" },
    { title: "Book Appointment", link: "/booking" },
    { title: "Hair Guide", link: "/hair-guide" },
    { title: "For You", link: "/for-you" },
    { title: "Contact Us", link: "/contact-us" },
  ];
  return (
    <div className="fixed z-[50] w-full ">
      <div className="bg-black text-white w-full">
        <div className="h-[4vh] w-full lg:hidden flex  justify-center items-center">
          <div className="flex items-center gap-1">
            <h6 className="sm:text-sm text-xs">inquiry@glowwithkindness.com</h6>
          </div>
        </div>
        <div className=" px-[5%] w-full   max-w-[1440px] mx-auto h-[6vh] text-center text-xs lg:flex hidden justify-between   items-center text-semibold">
          <div className="flex gap-5  items-center">
            {" "}
            <div className="flex items-center gap-1">
              <CiLocationOn className="text-[20px] gold-shine-icon" />
              <h6 className="sm:text-sm text-xs">
                2650 Midway Rd Unit 140 & 240 Carrollton, TX 75006 United States
              </h6>
            </div>
            <div className="flex items-center gap-1">
              <FiPhone className="text-[16px] gold-shine-icon" />
              <h6 className="sm:text-sm text-xs">(469) 670-0124</h6>
            </div>
            <div className="flex items-center gap-1">
              <MdOutlineEmail className="text-[20px] gold-shine-icon" />
              <h6 className="sm:text-sm text-xs">
                inquiry@glowwithkindness.com
              </h6>
            </div>
          </div>
          <div className="flex items-center gap-4 text-[20px]">
            <a
              href="https://www.facebook.com/profile.php?id=100067823421564"
              className="hover:brightness-110 transition"
            >
              <FaFacebookF className="gold-shine-icon" />
            </a>
            <a
              href="https://www.instagram.com/glowwithkindness/"
              className="hover:brightness-110 transition"
            >
              <FaInstagram className="gold-shine-icon" />
            </a>
            <a
              href="https://www.tiktok.com/@glowwwithkindness"
              className="hover:brightness-110 transition"
            >
              <FaTiktok className="gold-shine-icon" />
            </a>
            <a
              href="https://x.com/GlowwithK"
              className="hover:brightness-110 transition"
            >
              <FaTwitter className="gold-shine-icon" />
            </a>
          </div>
        </div>
        <div className="bg-black text-white border-t border-gold/20">
          <div className="max-w-[1440px] mx-auto flex justify-between items-center w-full sm:h-[13vh] h-[10vh] px-[5%] ">
            <Link to="/">
              <img
                className="sm:w-[100px] w-[70px]"
                src="/glowlogo.png"
                alt="GlowWithKindness logo"
              />
            </Link>
            <nav className="flex items-center text-white lg:gap-7">
              <ul className="lg:flex hidden lg:gap-7 items-center text-sm uppercase">
                {[
                  { to: "/", label: "Home" },
                  { to: "/about", label: "About us" },
                  { to: "/hair-guide", label: "Hair Guide" },
                  { to: "/for-you", label: "For You" },
                  { to: "/contact-us", label: "Contact us" },
                ].map((item) => (
                  <NavLink
                    key={item.to}
                    to={item.to}
                    end={item.to === "/"}
                    className={({ isActive }) =>
                      isActive
                        ? "text-gold font-semibold"
                        : "text-white hover:text-gold transition-colors"
                    }
                  >
                    <li>{item.label}</li>
                  </NavLink>
                ))}
              </ul>

              <div className="lg:flex hidden gap-7 items-center">
                <Link to="/booking">
                  <button className=" sm:flex hidden py-2.5 px-6 text-black font-semibold bg-gold-shine rounded-[50px] border border-gold-dark/60 shadow-[0_4px_16px_rgba(212,175,55,0.4)] hover:shadow-[0_6px_20px_rgba(212,175,55,0.6)] hover:brightness-110 transition-all">
                    Book Now
                  </button>
                </Link>
              </div>
            </nav>

            <div className="lg:hidden flex">
              <HiOutlineMenuAlt3
                onClick={toggleMenu}
                className="text-[30px] text-white cursor-pointer"
              />
            </div>
          </div>
        </div>
        <div>
          {" "}
          <AnimatePresence>
            {open && (
              <motion.div
                variants={menuVars}
                initial="initial"
                animate="animate"
                exit="exit"
                className="fixed z-[10000000] left-0 top-0 h-screen w-full origin-top bg-black text-white py-[7%] px-[5%]"
              >
                <div className="absolute top-0 left-0 w-full h-1 bg-gold-shine" />
                <div className="flex h-full flex-col">
                  <div className="flex justify-between items-center">
                    <Link to="/" onClick={toggleMenu}>
                      <img
                        className="w-[70px]"
                        src="/glowlogo.png"
                        alt="GlowWithKindness logo"
                      />
                    </Link>
                    <button
                      onClick={toggleMenu}
                      className="w-[44px] h-[44px] bg-gold-shine text-black rounded-full flex items-center justify-center shadow-[0_4px_16px_rgba(212,175,55,0.45)] hover:brightness-110 transition-all"
                    >
                      <IoCloseOutline className="text-[24px]" />
                    </button>
                  </div>
                  <motion.div
                    variants={containerVars}
                    initial="initial"
                    animate="open"
                    exit="initial"
                    className="flex h-full flex-col items-center justify-center gap-4"
                  >
                    {nav.map((item) => (
                      <div key={item.link} onClick={toggleMenu}>
                        <MobileNavLink title={item.title} link={item.link} />
                      </div>
                    ))}
                  </motion.div>
                  <div className="flex flex-col items-center gap-4 mb-[15%]">
                    <div className="flex items-center gap-1">
                      <div className="w-[40px] bg-primary h-[3px]" />
                      <div className="w-[20px] bg-gold-bar h-[3px] rounded-full" />
                    </div>
                    <div className="flex items-center gap-10 text-[22px] text-white">
                      <a
                        href="https://www.facebook.com/profile.php?id=100067823421564"
                        className="hover:text-gold transition-colors"
                      >
                        <FaFacebookF />
                      </a>
                      <a
                        href="https://www.instagram.com/glowwithkindness/"
                        className="hover:text-gold transition-colors"
                      >
                        <FaInstagram />
                      </a>
                      <a
                        href="https://www.tiktok.com/@glowwwithkindness"
                        className="hover:text-gold transition-colors"
                      >
                        <FaTiktok />
                      </a>
                      <a
                        href="https://x.com/GlowwithK"
                        className="hover:text-gold transition-colors"
                      >
                        <FaTwitter />
                      </a>
                    </div>
                  </div>
                </div>
              </motion.div>
            )}
          </AnimatePresence>
        </div>
      </div>
    </div>
  );
}
const MobileNavLink = ({ title, link }) => {
  return (
    <motion.div variants={mobileLinkVars} className="text-2xl uppercase">
      <NavLink
        to={link}
        end={link === "/"}
        className={({ isActive }) =>
          isActive
            ? "text-gold font-semibold"
            : "text-white hover:text-gold transition-colors"
        }
      >
        {title}
      </NavLink>
    </motion.div>
  );
};
